"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Icon_1 = tslib_1.__importDefault(require("@ant-design/icons/lib/components/Icon"));
/**
 * [table-eye](https://github.com/Templarian/MaterialDesign-SVG/blob/master/svg/table-eye.svg) icon from [Material Design](https://github.com/Templarian/MaterialDesign)
 *
 * @author Terren
 * @version 4.2.95
 */
function TableEyeIcon(props) {
    return React.createElement(Icon_1.default, tslib_1.__assign({ component: SVG }, props));
}
exports.default = TableEyeIcon;
var SVG = function () { return React.createElement("svg", { width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" },
    React.createElement("path", { d: "M17 16.88C17.56 16.88 18 17.32 18 17.88S17.56 18.88 17 18.88 16 18.43 16 17.88 16.44 16.88 17 16.88M17 13.88C19.73 13.88 22.06 15.54 23 17.88C22.06 20.22 19.73 21.88 17 21.88S11.94 20.22 11 17.88C11.94 15.54 14.27 13.88 17 13.88M17 15.38C15.62 15.38 14.5 16.5 14.5 17.88S15.62 20.38 17 20.38 19.5 19.26 19.5 17.88 18.38 15.38 17 15.38M18 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H9.42C9.26 18.68 9.12 18.34 9 18C9.12 17.66 9.26 17.32 9.42 17H4V13H10V15.97C10.55 15.11 11.23 14.37 12 13.76V13H13.15C14.31 12.36 15.62 12 17 12C18.06 12 19.07 12.21 20 12.59V5C20 3.9 19.1 3 18 3M10 11H4V7H10V11M18 11H12V7H18V11Z" })); };
